import "../CSS/Login.css";
import logo from "../assets/gtechlogo.png";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  changePassword,
  login,
  sendOTP,
} from "../redux/actions/CustomerAction";
import {
  CHANGE_PASSWORD_RESET,
  CUSTOMER_LOGIN_RESET,
  SEND_OTP_RESET,
} from "../Constants/Constants";
import NotificationPopup from "../Components/NotificationPopup";

export default function Login(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const customer_user_id = JSON.parse(localStorage.getItem("customer_user_id"));
  const [page, setPage] = useState(props.page);
  const [snackOpen, setSnackOpen] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [otpSent, setOtpSent] = useState(false); // Track OTP sent status
  const [otpResendCountdown, setOtpResendCountdown] = useState(30); // Countdown for resend
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  const [userType, setUserType] = useState("customer");
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [OTP, setOTP] = useState(null);
  const [usernameF, setUsernameF] = useState(null);
  const [new_password, setNewPassword] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [confirm_password, setConfirmPassword] = useState(null);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [successLoginNotificationOpen, setSuccessLoginNotificationOpen] =
    useState(false);
  const [errorNotificationOpen, setErrorNotificationOpen] = useState(false);
  const [fieldErrorNotificationOpen, setFieldErrorNotificationOpen] =
    useState(false);
  const [fieldErrorNotificationMessage, setFieldErrorNotificationMessage] =
    useState("");
  const [fieldErrorNotificationTitle, setFieldErrorNotificationTitle] =
    useState("");
  const [fieldErrorNotificationSeverity, setFieldErrorNotificationSeverity] =
    useState("error");
  const [
    successChangePasswordNotificationOpen,
    setSuccessChangePasswordNotificationOpen,
  ] = useState(false);

  const loginResponse = useSelector((state) => state.CustomerLogin);
  const { token, loginerror } = loginResponse;

  const SendOTPData = useSelector((state) => state.SendOTPData);
  const { sendOTPerror, sendOTPInfo } = SendOTPData;

  const ChangePassword = useSelector((state) => state.ChangePassword);
  const { changePasswordError, changePasswordInfo } = ChangePassword;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    setUsername("");
    setPassword("");
    setOTP("");
    setUsernameF("");
    setNewPassword("");
    setConfirmPassword("");
  }, []);

  useEffect(() => {
    if (token) {
      setSuccessLoginNotificationOpen(true);
    }
  }, [token]);

  useEffect(() => {
    if (sendOTPerror || loginerror) {
      setErrorNotificationOpen(true);
    }
  }, [sendOTPerror, loginerror]);

  useEffect(() => {
    if (sendOTPInfo) {
      setSuccessLoginNotificationOpen(true);
    }
  }, [sendOTPInfo]);

  useEffect(() => {
    let interval;
    if (otpSent && otpResendCountdown > 0) {
      interval = setInterval(() => {
        setOtpResendCountdown((prev) => prev - 1);
      }, 1000);
    } else if (otpResendCountdown === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, otpResendCountdown]);

  useEffect(() => {
    sendOTPerror && setPage("login");
    // sendOTPInfo && setPage("otp");
  }, [sendOTPerror, sendOTPInfo]);

  useEffect(() => {
    if (changePasswordError) {
      setErrorNotificationOpen(true);
      setPage("changepassword");
    }
    if (changePasswordInfo) {
      setSuccessChangePasswordNotificationOpen(true);
      setPage("login");
    }
  }, [changePasswordError, changePasswordInfo]);

  const handleEmailValidation = (email) => {
    setEmailError(!emailRegex.test(email));
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowOTP = () => setShowOTP((show) => !show);
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (page === "login") {
      setSnackOpen(true);
      dispatch({ type: CUSTOMER_LOGIN_RESET });
      if (username && password && !emailError) {
        const requestData = {
          username: username,
          password: password,
          from: "login",
          userType: userType,
        };
        dispatch(sendOTP(requestData));
        setOtpSent(true);
        setOtpResendCountdown(30); // Start countdown for resend
        setPage("otp");
      } else {
        setFieldErrorNotificationOpen(true);
        setFieldErrorNotificationMessage(
          "Please enter valid email and password"
        );
        setFieldErrorNotificationTitle("Error");
        setFieldErrorNotificationSeverity("error");
      }
    }
    if (page === "otp") {
      dispatch({ type: SEND_OTP_RESET });
      setSnackOpen(true);
      if (username && password && OTP) {
        const requestData = {
          username: username,
          password: password,
          otp: OTP,
          userType: userType,
        };
        dispatch(login(requestData));
      } else {
        setFieldErrorNotificationOpen(true);
        setFieldErrorNotificationMessage("Please enter valid OTP");
        setFieldErrorNotificationTitle("Error");
        setFieldErrorNotificationSeverity("error");
      }
    }
  };

  const handleResetOTP = (e) => {
    setPage("otp");
    setOtpSent(false); // Reset OTP sent flag and trigger resend
    setOTP(null);
    dispatch({ type: SEND_OTP_RESET });
    dispatch({ type: CUSTOMER_LOGIN_RESET });
    e.preventDefault();
    const requestData = {
      username: username,
      password: password,
      from: "login",
      userType: userType,
    };
    dispatch(sendOTP(requestData));
    setSnackOpen(true);
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    if (!userType) {
      setFieldErrorNotificationOpen(true);
      setFieldErrorNotificationMessage("Please select a user type");
      setFieldErrorNotificationTitle("Error");
      setFieldErrorNotificationSeverity("error");
      return;
    }
    if (usernameF) {
      setSnackOpen(true);
      const requestData = {
        username: usernameF,
        from: "forgot_password",
        userType: userType,
      };
      dispatch(sendOTP(requestData)).then((response) => {
        console.log("response", response);
        if (response) {
          setPage("changepassword");
        } else {
          setPage("forgotPassword");
        }
      });
    } else {
      setFieldErrorNotificationOpen(true);
      setFieldErrorNotificationMessage("Please enter valid email");
      setFieldErrorNotificationTitle("Error");
      setFieldErrorNotificationSeverity("error");
    }
  };

  const handleHeadingText = () => {
    if (page == "otp") {
      return "Enter OTP";
    } else if (page == "forgotPassword") {
      return "Forgot Password";
    } else if (page == "resetPassword") {
      return "Reset your password";
    } else if (page == "changepassword") {
      return "Change Password";
    } else {
      return "AIRLINE LOGIN PORTAL";
    }
  };

  const goBackToLogin = () => {
    setPage("login");
    setUsername("");
    setUsernameF("");
    setPassword("");
    setOTP("");
    setOtpSent(false);
    setOtpResendCountdown(30); // Reset countdown
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const handleChangePassword = (e) => {
    if (new_password === confirm_password) {
      const requestData = {
        new_password: new_password,
        confirm_password: confirm_password,
        userType: userType,
        otp: OTP,
      };
      let id = null;
      if (userType == "customer") {
        id = customer_id;
      }
      if (userType == "customer_user") {
        id = customer_user_id;
      }

      dispatch(changePassword(id, requestData));
    } else {
      setFieldErrorNotificationOpen(true);
      setFieldErrorNotificationMessage("Passwords do not match");
      setFieldErrorNotificationTitle("Error");
      setFieldErrorNotificationSeverity("error");
    }
  };

  return (
    <div className="login-container-bg">
      <div className="login-container">
        <div className="logoimgnw">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <Box className="login-form">
          <Typography variant="h4" className="login-title">
            {handleHeadingText()}
          </Typography>

          {page == "airlineLogin" ? (
            <>
              <TextField
                label="Username"
                variant="outlined"
                required
                fullWidth
                error={emailError}
                value={username}
                onChange={(e) => {
                  const usernameValue = e.target.value;
                  setUsername(usernameValue);
                  if (usernameValue.includes("@")) {
                    handleEmailValidation(usernameValue); // Validate email if it contains '@'
                  } else {
                    setEmailError(false); // Reset email error for non-email usernames
                  }
                }}
                InputProps={{
                  // input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon color="action" />
                    </InputAdornment>
                  ),
                  // },
                }}
              />
              {emailError && (
                <FormHelperText error>Invalid email format</FormHelperText>
              )}

              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => {
                  const passwordValue = e.target.value;
                  setPassword(passwordValue);
                }}
                required
                InputProps={{
                  // input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  // },
                }}
              />
              
              <Button
                className="login-button"
                variant="contained"
                type="submit"
                onClick={handleLogin}
                fullWidth
              >
                LOGIN
              </Button>
              <div className="forgot-link">
                <NavLink
                  onClick={() => {
                    setPage("forgotPassword");
                    dispatch({ type: SEND_OTP_RESET });
                  }}
                >
                  Forgot Password?
                </NavLink>
              </div>
            </>
          ) : page == "otp" ? (
            <>
              <TextField
                required
                fullWidth
                label="One Time Password (OTP)"
                className="otp-input"
                value={OTP || ""}
                type={showOTP ? "text" : "password"}
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  e.target.value = value;
                  setOTP(value);
                }}
                InputProps={{
                  // input: {
                  // pattern: "[0-9]*",
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowOTP}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showOTP ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  // },
                }}
              />
              <Button
                className="login-button"
                variant="contained"
                type="submit"
                onClick={handleLogin}
                fullWidth
              >
                Submit OTP
              </Button>
              <div className="resent-button-div">
                <Button
                  className="resend-button"
                  variant="outlined"
                  onClick={handleResetOTP}
                  disabled={otpResendCountdown > 0}
                >
                  Resend OTP
                  {otpResendCountdown > 0 ? `(${otpResendCountdown}s)` : ""}
                </Button>
              </div>
            </>
          ) : page == "forgotPassword" ? (
            <>
              <TextField
                label="Username"
                variant="outlined"
                required
                fullWidth
                error={emailError}
                value={usernameF}
                onChange={(e) => {
                  const emailValue = e.target.value;
                  setUsernameF(emailValue);
                  if (usernameF.includes("@")) {
                    handleEmailValidation(emailValue); // Validate email if it contains '@'
                  } else {
                    setEmailError(false);
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="user-type">
                <RadioGroup
                  name="Type"
                  value={userType}
                  onChange={handleUserTypeChange}
                  row
                >
                  <FormControlLabel
                    value="customer"
                    control={<Radio />}
                    label="Customer"
                  />
                  <FormControlLabel
                    value="customer_user"
                    control={<Radio />}
                    label="Customer User"
                  />
                </RadioGroup>
              </div>

              <Typography
                sx={{
                  textAlign: "center",
                  color: "#313639",
                }}
              >
                OTP will be sent to your registered email
              </Typography>
              <Button
                className="login-button"
                variant="contained"
                type="submit"
                onClick={handleSendOTP}
                fullWidth
              >
                Send OTP
              </Button>

              <div className="forgot-link">
                <NavLink href="#" onClick={goBackToLogin}>
                  Already have an account? Login
                </NavLink>
              </div>
            </>
          ) : page == "changepassword" ? (
            <>
              <TextField
                required
                fullWidth
                label="One Time Password (OTP)"
                className="otp-input"
                value={OTP || ""}
                type={showOTP ? "text" : "password"}
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  e.target.value = value;
                  setOTP(value);
                }}
                InputProps={{
                  pattern: "[0-9]*",
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowOTP}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showOTP ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                required
                fullWidth
                label="New Password"
                className="otp-input"
                value={new_password || ""}
                type={showNewPassword ? "text" : "password"}
                variant="outlined"
                onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
                  pattern: "[0-9]*",
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowNewPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showNewPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                required
                fullWidth
                label="Confirm Password"
                className="otp-input"
                value={confirm_password || ""}
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  pattern: "[0-9]*",
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowConfirmPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                className="login-button"
                variant="contained"
                type="submit"
                onClick={handleChangePassword}
                fullWidth
              >
                Change Password
              </Button>
            </>
          ) : null}
        </Box>
      </div>
      {token && (
        <NotificationPopup
          open={successLoginNotificationOpen}
          onClose={() => {
            setSuccessLoginNotificationOpen(false);
          }}
          message={"You have successfully logged in!"}
          severity={"success"}
        />
      )}
      {(sendOTPerror || loginerror) && (
        <NotificationPopup
          open={errorNotificationOpen}
          onClose={() => {
            setErrorNotificationOpen(false);
            dispatch({ type: SEND_OTP_RESET });
            dispatch({ type: CUSTOMER_LOGIN_RESET });
          }}
          message={sendOTPerror || loginerror}
          severity={"error"}
        />
      )}
      {sendOTPInfo && (
        <NotificationPopup
          open={successLoginNotificationOpen}
          onClose={() => {
            setSuccessLoginNotificationOpen(false);
          }}
          message={sendOTPInfo}
          severity={"success"}
        />
      )}
      {fieldErrorNotificationOpen && (
        <NotificationPopup
          open={fieldErrorNotificationOpen}
          onClose={() => {
            setFieldErrorNotificationOpen(false);
          }}
          message={fieldErrorNotificationMessage}
          title={fieldErrorNotificationTitle}
          severity={fieldErrorNotificationSeverity}
        />
      )}
      {changePasswordError && (
        <NotificationPopup
          open={errorNotificationOpen}
          onClose={() => {
            setErrorNotificationOpen(false);
            dispatch({ type: CHANGE_PASSWORD_RESET });
            setOTP("");
          }}
          message={changePasswordError}
          severity={"error"}
        />
      )}
      {changePasswordInfo && (
        <NotificationPopup
          open={successChangePasswordNotificationOpen}
          onClose={() => {
            setSuccessChangePasswordNotificationOpen(false);
            dispatch({ type: CHANGE_PASSWORD_RESET });
            setOTP("");
          }}
          message={changePasswordInfo}
          severity={"success"}
        />
      )}
    </div>
  );
}

